import React, {useState, useEffect} from "react";
import Sidebar from "../Components/Sidebar";

const Layout = ({children, pageTitle}) => {
    const [isMobileOpen, setIsMobileOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [collapsed, setCollapsed] = useState(false);

    // Check if mobile view based on screen width
    useEffect(() => {
        const checkMobile = () => {
            const mobile = window.innerWidth < 1024;
            setIsMobile(mobile);
            if (mobile) {
                setCollapsed(false); // Reset collapse state on mobile
            }
        };

        checkMobile();
        window.addEventListener("resize", checkMobile);

        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    return (
        <div className="font-['Poppins']">

            <div className="flex">
                {/* Sidebar - IMPORTANT: Pass collapsed and setCollapsed props */}
                <aside
                    className={`
                        ${isMobile ? 'w-0' : collapsed ? 'w-20' : 'w-64'} 
                        h-screen fixed top-0 z-50 transition-all duration-300
                    `}
                >
                    <Sidebar
                        isMobileOpen={isMobileOpen}
                        setIsMobileOpen={setIsMobileOpen}
                        collapsed={collapsed}
                        setCollapsed={setCollapsed}
                    />
                </aside>

                {/* Main Content */}
                <div
                    className={`
                        w-full transition-all duration-300 
                        ${isMobile ? 'ml-0' : collapsed ? 'ml-20' : 'ml-64'}
                    `}
                    style={{
                        marginLeft: isMobile ? '0' : (collapsed ? '80px' : '256px')
                    }}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Layout;